// src/icons/LoadingCircleLines.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function LoadingCircleLines() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0004 3.57361e-09C10.4146 4.00036e-05 10.7503 0.33585 10.7503 0.75007L10.75 4.25007C10.75 4.66428 10.4141 5.00004 9.9999 5C9.5857 4.99996 9.25 4.66415 9.25 4.24993L9.2503 0.74993C9.2503 0.33572 9.5862 -3.99964e-05 10.0004 3.57361e-09ZM2.92919 2.92867C3.22211 2.6358 3.69699 2.63584 3.98985 2.92876L6.46451 5.40385C6.75738 5.69677 6.75734 6.17164 6.46442 6.46451C6.1715 6.75738 5.69663 6.75734 5.40376 6.46442L2.9291 3.98933C2.63623 3.69641 2.63628 3.22154 2.92919 2.92867ZM17.0716 2.92943C17.3645 3.22232 17.3645 3.69719 17.0716 3.99009L14.5967 6.46496C14.3038 6.75785 13.8289 6.75785 13.536 6.46496C13.2431 6.17207 13.2431 5.69719 13.536 5.4043L16.0109 2.92943C16.3038 2.63653 16.7787 2.63653 17.0716 2.92943ZM0 10.0007C0 9.5865 0.33579 9.2507 0.75 9.2507H4.25C4.66421 9.2507 5 9.5865 5 10.0007C5 10.4149 4.66421 10.7507 4.25 10.7507H0.75C0.33579 10.7507 0 10.4149 0 10.0007ZM15 10.0007C15 9.5865 15.3358 9.2507 15.75 9.2507H19.25C19.6642 9.2507 20 9.5865 20 10.0007C20 10.4149 19.6642 10.7507 19.25 10.7507H15.75C15.3358 10.7507 15 10.4149 15 10.0007ZM13.5357 13.5353C13.8286 13.2424 14.3035 13.2424 14.5964 13.5353L17.0713 16.0102C17.3642 16.3031 17.3642 16.778 17.0713 17.0709C16.7784 17.3637 16.3035 17.3637 16.0106 17.0709L13.5357 14.596C13.2429 14.3031 13.2429 13.8282 13.5357 13.5353ZM6.46496 13.536C6.75785 13.8289 6.75785 14.3038 6.46496 14.5967L3.99009 17.0716C3.69719 17.3645 3.22232 17.3645 2.92943 17.0716C2.63653 16.7787 2.63653 16.3038 2.92943 16.0109L5.4043 13.536C5.69719 13.2431 6.17207 13.2431 6.46496 13.536ZM10.0003 15C10.4145 15 10.7503 15.3358 10.7503 15.75V19.25C10.7503 19.6642 10.4145 20 10.0003 20C9.5861 20 9.2503 19.6642 9.2503 19.25V15.75C9.2503 15.3358 9.5861 15 10.0003 15Z",
          fill: "currentColor"
        }
      )
    }
  );
}

export {
  LoadingCircleLines
};
